<template>
    <div style="margin: 15px; border: 5px solid #00CC66; border-radius: 15px; padding: 15px;" v-if="dosage">
        {{$t('dosage_editor.dose')}}:
        <input style="width: 50px;" v-model="dosage.dosage" v-if="dosage.dosage > 0" id="dosage" disabled="true"/>
        <input style="width: 50px;" v-model="dosage.new_dose" v-if="dosage.dosage == 0" id="new_dose" /> {{dosage.dosage_unit}} <br />
        <template v-if="withConsumption">
            {{$t('dosage_editor.consumed')}}:
            <p class="range-field">
                <input type="range" v-model="dosage.consumed" id="consumed" min="0" :max="dosage.dosage" />
            </p>
            <p>{{dosage.consumed}}</p>
        </template>
        <template v-if="dosage.dosage > 0">
            {{$t('dosage_editor.replaced_completed')}}:
            <p class="range-field">
                <input type="range" v-model="dosage.replaced" id="replaced" min="0" :max="dosage.dosage" />
            </p>
            <p>{{dosage.replaced}}</p>
            <template v-if="dosage.dosage > 0">
                <span>
                    <label>
                        <input v-model="dosage.dose_change" type="checkbox" id="dose_change" />
                        <span>{{$t('dosage_editor.change_dosage')}}</span>
                    </label>
                </span><br />
            </template>
            <template v-if="dosage.dose_change">{{$t('dosage_editor.new_dosage')}}: <input style="width: 50px;" v-model="dosage.new_dose" id="new_dose" /> {{dosage.dosage_unit}}</template>
        </template>
    </div>
</template>
<script>
import axios from 'axios';
import _ from 'lodash';
export default {
    data: function() {
        return {
            searchterm: ""
        }
    },
    props: {
        selections: {
            type: [Array, Number],
            default () {
                return []
            }
        },
        dosage: Object,
        items: Array,
        identifier: String,
        disabled: Boolean,
        elongating: Boolean,
        singlemode: Boolean,
        groupitems: String,
        withConsumption: Boolean
    },
    model: {
        prop: 'selections',
        event: 'listchange'
    }
}
</script>
<style scoped>
.searchterm {
    min-height: initial;
}

.searchterm input {
    margin: 0px;
    width: 95%;
}

.input-field {
    width: 100% !important;
}

.select-wrapper {
    width: 100% !important;
    margin-right: 0px !important;
    margin-left: 0px !important;
}

[type="checkbox"]:checked+span:not(.lever):before {
    border-right: 2px solid #000;
    border-bottom: 2px solid #000;
}

.dropdown-content p {
    margin-top: 0px;
    margin-bottom: 0px;
}

.elongating {
    border: 1px solid #9e9e9e;
    margin-bottom: 15px;
    border-radius: 4px;
    padding: 15px;
}

input[type=range] {
    border: 0px !important;
}
</style>